import React from 'react';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import style from "./../../assets/styles/componentStyles/userProfileStyles/userProfileStyle.module.scss";
import popupStyles from "./../../assets/styles/componentStyles/globalPopupStyles.module.scss";
import globalStyle from "../../assets/styles/global.module.scss"
import EditIcon from '@mui/icons-material/Edit';
import { getValueOrDefault } from '../../utils/constants';

interface UserTimezoneSectionProps {
    timezoneName?: string;
    onClickTimezoneAction: () => void;
}

const UserTimezoneSection: React.FC<UserTimezoneSectionProps> = ({ timezoneName, onClickTimezoneAction }) => {
    const isSmallScreen = useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)');

    return (
        <Grid item xs={12}>
            <Grid container gap={"8px"} className={`${globalStyle.displayFlexStyle} ${globalStyle.flexColumn}`}>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyle.displayFlex}`} gap={1}>
                        <Grid item>
                            <Typography className={style.userDetailTitle}>
                                Timezone
                            </Typography>
                        </Grid>
                        <Grid item className={`${globalStyle.displayFlexStyle} ${globalStyle.clickable}`} onClick={onClickTimezoneAction}>
                            <EditIcon className={style.editUserDetailIcon} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={style.userProfileDetailsCard}>
                    <Grid container gap="10px" flexWrap="nowrap" direction={isSmallScreen ? "column" : "row"}>
                        <Grid item xs={isSmallScreen ? 12 : 4}>
                            <Typography className={popupStyles.popupFieldGreyTypography}>
                                Timezone Name
                            </Typography>
                        </Grid>
                        <Grid item xs={isSmallScreen ? 12 : 8}>
                            <Typography className={popupStyles.popupFieldTypography}>
                                {getValueOrDefault(timezoneName)}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default UserTimezoneSection;
